import {
  AUTH_ERROR_CODES,
  OTP_ERROR_CODES,
  SERVER_ERROR_CODES,
  AVAILABILITY_ERROR_CODES,
  APPOINTMENT_ERROR_CODES,
  TOKEN_ERROR_CODES,
} from './constants';

/**
 * @typedef {Object} Error
 * @property {string} code
 * @property {string} detail
 */

/**
 * @param {Error Object} error
 * @returns {boolean}
 */
const isInvalidCredentialsError = error => {
  return error?.code === AUTH_ERROR_CODES.INVALID_CREDENTIALS;
};

const isRateLimitExceededError = error => {
  return error?.code === AUTH_ERROR_CODES.RATE_LIMIT_EXCEEDED;
};

const isMissingParameterError = error => {
  return (
    error?.code === AUTH_ERROR_CODES.MISSING_PARAMETER ||
    error?.code === OTP_ERROR_CODES.MISSING_PARAMETER ||
    error?.code === APPOINTMENT_ERROR_CODES.MISSING_PARAMETER
  );
};

const isAccountLockedError = error => {
  return error?.code === OTP_ERROR_CODES.ACCOUNT_LOCKED;
};

const isServerError = error => {
  return (
    Object.values(SERVER_ERROR_CODES).includes(error?.code) ||
    error?.status >= 400 ||
    error?.status >= 500
  );
};

const isNotWhithinCohortError = error => {
  return error?.code === AVAILABILITY_ERROR_CODES.NOT_WITHIN_COHORT;
};

const isNoSlotsAvailableError = error => {
  return error?.code === AVAILABILITY_ERROR_CODES.NO_SLOTS_AVAILABLE;
};

const isAppointmentFailedError = error => {
  return error?.code === APPOINTMENT_ERROR_CODES.APPOINTMENT_SAVE_FAILED;
};

const isInvalidVeteranTimezoneError = error => {
  return error?.code === APPOINTMENT_ERROR_CODES.INVALID_VETERAN_TIME_ZONE;
};

const isAppointmentNotFoundError = error => {
  return error?.code === APPOINTMENT_ERROR_CODES.APPOINTMENT_NOT_FOUND;
};

const isAppointmentAlreadyBookedError = error => {
  return error?.code === AVAILABILITY_ERROR_CODES.APPOINTMENT_ALREADY_BOOKED;
};

const isCancellationFailedError = error => {
  return error?.code === APPOINTMENT_ERROR_CODES.CANCELLATION_FAILED;
};

const isMissingContactInformationError = error => {
  return error?.code === AUTH_ERROR_CODES.MISSING_CONTACT_INFORMATION;
};

const isNotificationError = error => {
  return error?.code === AUTH_ERROR_CODES.NOTIFICATION_ERROR;
};

/**
 * True only for session-auth failures on authenticated endpoints. Excludes OTP
 * 401s and 502 `upstream_auth_error`, which re-verifying cannot fix.
 */
const isSessionAuthError = error => {
  return (
    error?.code === TOKEN_ERROR_CODES.UNAUTHORIZED ||
    error?.code === TOKEN_ERROR_CODES.MISSING_EDIPI
  );
};

export {
  isSessionAuthError,
  isInvalidCredentialsError,
  isRateLimitExceededError,
  isMissingParameterError,
  isAccountLockedError,
  isServerError,
  isNotWhithinCohortError,
  isNoSlotsAvailableError,
  isAppointmentFailedError,
  isInvalidVeteranTimezoneError,
  isAppointmentNotFoundError,
  isAppointmentAlreadyBookedError,
  isCancellationFailedError,
  isMissingContactInformationError,
  isNotificationError,
};
